import { word } from "@/modules/core/utils/i18n"
import { useSidebar } from "@/modules/sidebar/hooks/useSidebar"
import { SocialView } from "@/modules/social/components/socialView"

export const useSocialSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToSocialView = (socialPostId: string | null, sessionInfos: { id: string; name: string }) => {
    void sidebarNavigateTo({
      content: <SocialView socialPostId={socialPostId} sessionInfos={sessionInfos} />,
      leftButtonText: word("program.planning.create.exercise.returnSession"),
    })
  }

  return { navigateToSocialView }
}
